import React, { useState } from 'react';
import BaseCell from './BaseCell';
import Button from 'shared/buttons/BaseButton';
import { Chip } from '@progress/kendo-react-buttons';

const defaultValue = [];

const ListCell = ({
  items = defaultValue, renderItem, collapsible = false, ...props
}) => {
  const [collapsed, setCollapsed] = useState(true);

  if (!collapsible) {
    return (
      <BaseCell {...props}>
        {items.map((item) => (
          <div key={JSON.stringify({ item })}>
            {renderItem ? renderItem(item) : item}
          </div>
        ))}
      </BaseCell>
    );
  }

  const onExpand = (e) => {
    if (e.stopPropagation) {
      e.stopPropagation();
    }
    setCollapsed(false);
  };
  const onCollapse = (e) => {
    if (e.stopPropagation) {
      e.stopPropagation();
    }
    setCollapsed(true);
  };

  return (
    <BaseCell {...props}>
      {collapsed && (
        <>
          {renderItem && items.length > 0 ? renderItem(items[0]) : items[0]}
          {items.length > 1 && (
            <Chip onClick={onExpand}>
              {`+ ${items.length - 1}`}
            </Chip>
          )}
        </>
      )}
      {!collapsed && (
        <>
          {items.map((item) => (
            <div key={JSON.stringify({ item })}>
              {renderItem ? renderItem(item) : item}
            </div>
          ))}
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Button iconOnly onClick={onCollapse} fillMode="flat" icon="arrow-chevron-up" />
          </div>
        </>
      )}
    </BaseCell>
  );
};

export default ListCell;
